export const initialState = {
  item: {
    changed: false,
    saving: false
  }
};

export const reducer = (state, action) => {
  switch (action.type) {
    case 'OnInitState':
      return onInitState(state, action);
    case 'OnItemSaving':
      return onItemSaving(state);
    case 'OnItemSaved':
      return onItemSaved(state);
    case 'OnItemValuesChanged':
      return onItemValuesChanged(state, action);
    case 'OnItemAdded':
      return onItemAdded(state);

    default:
      return state;
  }
};

const onInitState = (state, action) => {
  const { clause } = action;
  const clauseId = action.clause.clauseId;
  return {
    ...state,
    clauseId,
    item: {
      ...clause,
      changed: false,
      saving: false
    }
  };
};

const onItemSaved = state => {
  return {
    ...state,
    item: {
      ...state.item,
      changed: false,
      saving: false
    }
  };
};

const onItemSaving = state => {
  return {
    ...state,
    item: {
      ...state.item,
      changed: false,
      saving: true
    }
  };
};

const onItemValuesChanged = (state, action) => {
  const { itemPropertyName, itemValue } = action;
  return {
    ...state,
    item: {
      ...state.item,
      [itemPropertyName]: itemValue,
      changed: true
    }
  };
};

const onItemAdded = state => {
  return {
    ...state,
    item: {
      ...state.item,
      clauseCode: '',
      clauseText: '',
      orderNo: '',
      clauseTypeId: null,
      documentTypeId: null,
      parentClauseId: null,
      validityDays: null,
      mandatory: false,
      formula: '',
      enabled: true
    }
  };
};
